<template>
    <div
        class="bg-cover bg-center bg-no-repat px-3 sm:px-6 py-12 z-10"
        :style="{
            backgroundImage: `url('${require('@/assets/img/fondos_pinguiigluu.jpg')}')`
        }"
    >
        <div
            class="flex flex-col items-center w-full max-w-screen-sm mx-auto border-2 border-orange py-10 bg-white"
        >
            <logo class="mb-10"></logo>

            <brush-stroke-bg :variant="2" class="mb-10">
                <h2 class="font-primary text-white text-3xl px-16">
                    {{ $config("RESET_PASSWORD") }}
                </h2>
            </brush-stroke-bg>

            <ValidationObserver v-slot="{ handleSubmit }" class="w-full">
                <form
                    class="flex flex-col items-center w-3/4 mx-auto"
                    @submit.prevent="handleSubmit(resetPassword)"
                    autocomplete="on"
                    novalidate
                >
                    <form-input
                        name="email"
                        type="email"
                        v-model="email"
                        :placeholder="$config('EMAIL')"
                        class="w-full mb-10"
                        required
                    ></form-input>

                    <form-input
                        name="password"
                        type="password"
                        v-model="password"
                        :placeholder="$config('PASSWORD')"
                        class="w-full mb-10"
                        required
                    ></form-input>

                    <btn
                        class="bg-orange text-white text-xl rounded-large px-10 mb-8"
                    >
                        {{ $config("ENVIAR") }}
                    </btn>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import allowGuestsOnly from "../mixins/allowGuestsOnly";
import Logo from "../components/Logo";
import BrushStrokeBg from "../components/BrushStrokeBg";
import FormInput from "../components/FormInput";
import Btn from "../components/Btn";
import requestWithInteractions from "../mixins/requestWithInteractions";
import api from "../api";

export default {
    name: "reset-password",

    components: { Logo, BrushStrokeBg, FormInput, Btn },

    mixins: [allowGuestsOnly, requestWithInteractions],

    data() {
        return {
            email: null,
            password: null,
            hash: null
        };
    },

    created() {
        if (this.$route.query.q) this.hash = this.$route.query.q;
    },

    methods: {
        resetPassword() {
            this.sendRequest(
                api.resetPassword(this.email, this.password, this.hash),
                {
                    beforeSendText: this.$config("SEND_MESSAGE"),
                    successText: this.$config("REC_OK"),

                    onSuccess: () => {
                        this.$router.push({ name: "home" });
                    }
                }
            );
        }
    }
};
</script>
